import { render, staticRenderFns } from "./maintenrecord.vue?vue&type=template&id=87abf15e"
import script from "./maintenrecord.vue?vue&type=script&lang=js"
export * from "./maintenrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports